import { Component, Inject, Input, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { PDAuthService } from 'pdauth';

import { InputConverter } from '../../inputConverter';
import { IAuthenticationService } from '../../services/interfaces/IAuthenticationService';
import { BaseComponent } from '../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-auth',
    styleUrls: ['../sharedStyles/base.scss'],
    templateUrl: './auth.component.html'
})
export class AuthComponent extends BaseComponent {
    @Input() appName: string;

    @Input()
    @InputConverter()
    showUser: boolean = true;

    @Input()
    @InputConverter()
    showEmail: boolean = true;

    @Input() prefix = 'User ';

    @Input() suffix: string;

    @Input()
    @InputConverter()
    forceLogin: boolean = false;

    @Input()
    @InputConverter()
    autoLogin: boolean = false;

    userString: string;

    @Input()
    get authUrl(): string {
        return this._authUrl;
    }
    set authUrl(val: string) {
        this._authUrl = val;
        this.initialize();
    }
    private _authUrl: string;

    @Input()
    get isLoggedIn() {
        return this.pdauth.isLoggedIn();
    }

    @Input()
    get user() {
        return this.pdauth.getLoggedInUser();
    }

    @Input()
    get permissions() {
        return this.pdauth.getLoggedInUserPermissions();
    }

    @Input()
    get isOnInternalNetwork() {
        return this.pdauth.getIsOnInternalNetwork();
    }

    @Input() get PDAuthService() {
        return this.pdauth;
    }

    constructor(
        vcr: ViewContainerRef,
        public readonly pdauth: PDAuthService,
        @Inject('authenticationService') public authService: IAuthenticationService) {
        super(vcr);
    }

    initialize() {
        if (!this.initialized) {
            this.initialized = true;
            this.pdauth.initialize(this.authUrl, this.appName);
            this.authService.GetCurrentUser().subscribe(user => {
                if (this.showEmail) {
                    this.userString = user ? user.emailAddress : 'None';
                } else {
                    this.userString = user ? user.fullName : 'None';
                }
            });

            if (this.forceLogin) {
                this.pdauth.enableForcedLogin();
            }

            if (this.autoLogin) {
                this.pdauth.logInAutomatically();
            }

            this.isReady();
        }
    }
    private initialized = false;

    @Input()
    login = () => {
        this.pdauth.authenticateUser();
    }

    @Input()
    logout = () => {
        this.pdauth.logOut();
    }
}
